import {Component, OnInit, Inject} from '@angular/core';
import {NeqErrorModel} from '@sharedcommon/model/neq-error.model';
import {FunctionUtils} from '@sharedcommon/util/functions.util';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import pkg from '@root/package.json';

@Component({
  templateUrl: './dialog-error.component.html',
})
export class NeqDialogErrorComponent implements OnInit {

  message: string;
  id: string;
  detail: string;
  appVersion: string;

  constructor(
    private readonly dialogRef: MatDialogRef<NeqDialogErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {message: string, neqError: NeqErrorModel, otherError: any}
  ) {
  }

  ngOnInit() {
    this.appVersion = pkg['version']||'test';
    let neqError: NeqErrorModel;
    let otherError: any;
    if (this.data) {
      if (this.data.message) {
        this.message = this.data.message;
      }
      if (this.data.neqError) {
        neqError = this.data.neqError;
      }
      if (this.data.otherError) {
        otherError = this.data.otherError;
      }
    }

    let detailError: string;
    if (FunctionUtils.isDefined(neqError)) {
      this.id = neqError.uuid;
      detailError = JSON.stringify(neqError, null, 2);
    } else {
      this.id = 'Not available';
      detailError = JSON.stringify(otherError, null, 2);
      if (detailError === '{}') {
        let typeError: TypeError;
        try {
          typeError = otherError;
          detailError = `message: ${typeError.message}\nstack: ${typeError.stack}`;
        } catch {
          detailError = otherError.toString();
        }
      }
    }

    this.detail = 'V' + this.appVersion + '\n' + detailError;
  }

  continue() {
    this.dialogRef.close();
  }

  /* To copy Text from Textbox */
  copyInputMessage(inputElement) {
    navigator.clipboard.writeText(inputElement.value);
    inputElement.setSelectionRange(0, 0);
  }
}
